import * as React from "react";
const SvgHierarchy = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { stroke: "currentColor", strokeWidth: 1.5 },
        React.createElement("path", { d: "M10.5 7H2V2h8.5v5ZM22 22H11v-4.5h11V22ZM22 14.5H11V10h11v4.5ZM6 7v12.75h5M6 12.25h5" }))));
export default SvgHierarchy;
